import { render, staticRenderFns } from "./system_seo_config.vue?vue&type=template&id=3d861636&scoped=true&"
import script from "./system_seo_config.vue?vue&type=script&lang=js&"
export * from "./system_seo_config.vue?vue&type=script&lang=js&"
import style0 from "./system_seo_config.vue?vue&type=style&index=0&id=3d861636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d861636",
  null
  
)

export default component.exports